import React, { useEffect, useState } from 'react'
import DOMPurify from 'dompurify';
import axios from "axios";
import {useNavigate} from "react-router-dom";
import {useParams} from "react-router-dom";

const NewsDetail = () => {
    const [data1, setData2] = useState([]);
  const {id} = useParams();
  const [data, setData] = useState([]);

console.log("id ====>",id)


  const newsData = () => {
    axios

      .post(
        "https://m1blog.aaragroups.com/blog/news-details-api/",
        {id: id},
        {
          headers: {
            Token: "6030357fc8126488bf023e910c0dbe35026608c4",
            "Access-Control-Allow-Origin": "*",
          },
        }
      )
      .then((res) => {
        console.log("RESPONSE  news data list ==== : ", res.data);
        setData(res.data.news_details[0]);
      })
      .catch((err) => {
        console.log("ERROR: ====", err);
        alert(err);
      });
  };

  useEffect(() => {
    newsData();
  }, [id]);

  const newsData2 = () => {

    axios
      .post("https://m1blog.aaragroups.com/blog/store-based-news-list-api/",{store_id:5}, {
        headers: {
     
          "Access-Control-Allow-Origin": "*",
        },
      })

      .then((res) => {
        console.log("RESPONSE ==== : ", res.data?.news_details);
        setData2(res.data?.news_details);
      })
      
      .catch((err) => {
        console.log("ERROR: ====", err);
      });
  };

  useEffect(() => {
    newsData2();
  }, []);

    const navigate = useNavigate()

    const sanitizedContent = DOMPurify.sanitize(data?.content);

  return (
    <>
    <div className='lg:flex-row flex flex-col bg-[#f0f5fc]  hm1'>
        <div className='lg:w-2/3 w-full lg:p-20 p-5'>
            <div className='text-center lg:p-5 p-2 shadow-xl rounded-lg border '><p className='text-[#0f75bc] lg:text-4xl text-2xl font-bold text-center py-2'>{data?.Title}</p>
            <p className='lg:text-xl text-base text-center font-semibold pt-3'>{data?.Title}</p></div>
            <div className='border rounded-xl shadow-xl p-5 my-5 pb-12'>
            <img src={data?.images} className='lg:p-16 p-6 lg:py-10 py-5'/>
            
            <div className='flex justify-between lg:px-16'><div
              dangerouslySetInnerHTML={{__html: sanitizedContent}}
            />
            <div className='flex bg-white rounded-full items-center justify-center'></div>
            </div>
            </div>
            
            <form className='lg:px-14 px-6 lg:py-14 py-4 mt-8 border rounded-lg shadow-lg'>
                <p className='lg:text-3xl text-2xl font-semibold py-2 text-center'>Comment</p>
                <input type='text' placeholder='Name' className='p-3 w-full border outline-none rounded-md my-2' />
                <input type='email' placeholder='Email' className='p-3 w-full border outline-none rounded-md my-2' />
                <input type='text' placeholder='Website' className='p-3 w-full border outline-none rounded-md my-2' />
                <textarea placeholder='Comment' rows={"4"} className='p-3 w-full border outline-none rounded-md my-2' />
                <div className='flex items-center justify-center'>
                <button className='text-white font-semibold text-xl my-1 w-full bg-violet-400 rounded-xl p-2 px-4' type='submit'>SUBMIT</button>
                </div>
            </form>
        </div>
        <div className='lg:w-1/3 w-full lg:p-20 p-7'>
            <div>
                <p className='font-semibold text-white py-3 text-xl'>RECENT NEWS</p>
                <hr/>
                {data1?.slice(0, 8)?.map((card) => (
                    <>
                <div className='flex gap-2 py-2' onClick={() => {
                      navigate(`/news/${card?.id}/${card?.slug}`);
                    }}>
                    <img src={card?.images} alt='' className='w-28'/>
                    <div className='flex flex-col items-center justify-around'>
                        <p className='text-lg font-semibold'>{card?.Title}</p>
                        <p>{card?.meta_description}</p>
                    </div>
                </div>
                <hr/>
                </>
                ))}
                
            </div>
        </div>
    </div>
    </>
  )
}

export default NewsDetail;
